import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';
import Button from 'atoms/Button/Button';
import Grid from 'atoms/Layout/Grid/Grid';

const PeopleMagicProfitAnnouncementBar = (): JSX.Element => (
  <Grid
    totalColumns={1}
    padding={['spacing-none', 'spacing-2xl']}
    paddingSm='spacing-none'
    maxWidth='width-3xl'
  >
    <Stack
      justify='center'
      align='center'
      gap='spacing-sm'
      gapLg='spacing-xl'
      directionLg='column'
    >
      <Stack
        direction='row'
        directionLg='column'
        justify='flex-start'
        gap='spacing-sm'
        marginRightLg='spacing-auto'
      >
        <Typography
          text='Join the FREE Masterclass'
          type='paragraph'
          size='md'
          fontWeight='font-weight-semibold'
          color='text-white'
        />
        <Typography
          type='paragraph'
          size='md'
          color='text-tertiary-on-brand'
          display='inline'
        >
          People Magic Profit: How to build a $1M Community{' '}
          <Button
            href='/community-design'
            size='lg'
            variant='brand-text-link'
            display='inline'
            decoration='underline'
          >
            Sign Up Now
          </Button>
        </Typography>
      </Stack>
    </Stack>
  </Grid>
);

export default PeopleMagicProfitAnnouncementBar;
